/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_AssignedInputs */

const en_case_history_verb_task_assigned = /** @type {(inputs: Case_History_Verb_Task_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`assigned to`)
};

const pt_br2_case_history_verb_task_assigned = /** @type {(inputs: Case_History_Verb_Task_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atribuída para`)
};

/**
* | output |
* | --- |
* | "assigned to" |
*
* @param {Case_History_Verb_Task_AssignedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_assigned = /** @type {((inputs?: Case_History_Verb_Task_AssignedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_AssignedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_assigned(inputs)
	return pt_br2_case_history_verb_task_assigned(inputs)
});